"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * StatsApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.3.3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
exports.StatsApi = exports.StatsApiFactory = exports.StatsApiFp = exports.StatsApiAxiosParamCreator = exports.VaultColumns = exports.VaultChallengeColumns = exports.StatusUpdateColumns = exports.RelayerChallengeColumns = exports.RedeemColumns = exports.IssueColumns = exports.FilterVaultColumnsComparisonEnum = exports.FilterVaultChallengeColumnsComparisonEnum = exports.FilterStatusUpdateColumnsComparisonEnum = exports.FilterRelayerChallengeColumnsComparisonEnum = exports.FilterRedeemColumnsComparisonEnum = exports.FilterIssueColumnsComparisonEnum = exports.BtcNetworkName = exports.BlockColumns = void 0;
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var base_1 = require("./base");
/**
 *
 * @export
 * @enum {string}
 */
var BlockColumns;
(function (BlockColumns) {
    BlockColumns["Height"] = "height";
    BlockColumns["Hash"] = "hash";
    BlockColumns["RelayTs"] = "relay_ts";
})(BlockColumns = exports.BlockColumns || (exports.BlockColumns = {}));
/**
 *
 * @export
 * @enum {string}
 */
var BtcNetworkName;
(function (BtcNetworkName) {
    BtcNetworkName["Mainnet"] = "mainnet";
    BtcNetworkName["Testnet"] = "testnet";
    BtcNetworkName["Regtest"] = "regtest";
})(BtcNetworkName = exports.BtcNetworkName || (exports.BtcNetworkName = {}));
/**
    * @export
    * @enum {string}
    */
var FilterIssueColumnsComparisonEnum;
(function (FilterIssueColumnsComparisonEnum) {
    FilterIssueColumnsComparisonEnum["Equal"] = "=";
    FilterIssueColumnsComparisonEnum["LessThan"] = "<";
    FilterIssueColumnsComparisonEnum["GreaterThan"] = ">";
})(FilterIssueColumnsComparisonEnum = exports.FilterIssueColumnsComparisonEnum || (exports.FilterIssueColumnsComparisonEnum = {}));
/**
    * @export
    * @enum {string}
    */
var FilterRedeemColumnsComparisonEnum;
(function (FilterRedeemColumnsComparisonEnum) {
    FilterRedeemColumnsComparisonEnum["Equal"] = "=";
    FilterRedeemColumnsComparisonEnum["LessThan"] = "<";
    FilterRedeemColumnsComparisonEnum["GreaterThan"] = ">";
})(FilterRedeemColumnsComparisonEnum = exports.FilterRedeemColumnsComparisonEnum || (exports.FilterRedeemColumnsComparisonEnum = {}));
/**
    * @export
    * @enum {string}
    */
var FilterRelayerChallengeColumnsComparisonEnum;
(function (FilterRelayerChallengeColumnsComparisonEnum) {
    FilterRelayerChallengeColumnsComparisonEnum["Equal"] = "=";
    FilterRelayerChallengeColumnsComparisonEnum["LessThan"] = "<";
    FilterRelayerChallengeColumnsComparisonEnum["GreaterThan"] = ">";
})(FilterRelayerChallengeColumnsComparisonEnum = exports.FilterRelayerChallengeColumnsComparisonEnum || (exports.FilterRelayerChallengeColumnsComparisonEnum = {}));
/**
    * @export
    * @enum {string}
    */
var FilterStatusUpdateColumnsComparisonEnum;
(function (FilterStatusUpdateColumnsComparisonEnum) {
    FilterStatusUpdateColumnsComparisonEnum["Equal"] = "=";
    FilterStatusUpdateColumnsComparisonEnum["LessThan"] = "<";
    FilterStatusUpdateColumnsComparisonEnum["GreaterThan"] = ">";
})(FilterStatusUpdateColumnsComparisonEnum = exports.FilterStatusUpdateColumnsComparisonEnum || (exports.FilterStatusUpdateColumnsComparisonEnum = {}));
/**
    * @export
    * @enum {string}
    */
var FilterVaultChallengeColumnsComparisonEnum;
(function (FilterVaultChallengeColumnsComparisonEnum) {
    FilterVaultChallengeColumnsComparisonEnum["Equal"] = "=";
    FilterVaultChallengeColumnsComparisonEnum["LessThan"] = "<";
    FilterVaultChallengeColumnsComparisonEnum["GreaterThan"] = ">";
})(FilterVaultChallengeColumnsComparisonEnum = exports.FilterVaultChallengeColumnsComparisonEnum || (exports.FilterVaultChallengeColumnsComparisonEnum = {}));
/**
    * @export
    * @enum {string}
    */
var FilterVaultColumnsComparisonEnum;
(function (FilterVaultColumnsComparisonEnum) {
    FilterVaultColumnsComparisonEnum["Equal"] = "=";
    FilterVaultColumnsComparisonEnum["LessThan"] = "<";
    FilterVaultColumnsComparisonEnum["GreaterThan"] = ">";
})(FilterVaultColumnsComparisonEnum = exports.FilterVaultColumnsComparisonEnum || (exports.FilterVaultColumnsComparisonEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
var IssueColumns;
(function (IssueColumns) {
    IssueColumns["IssueId"] = "issue_id";
    IssueColumns["AmountBtc"] = "amount_btc";
    IssueColumns["Requester"] = "requester";
    IssueColumns["FeePolkabtc"] = "fee_polkabtc";
    IssueColumns["GriefingCollateral"] = "griefing_collateral";
    IssueColumns["VaultWalletPubkey"] = "vault_wallet_pubkey";
    IssueColumns["BlockNumber"] = "block_number";
    IssueColumns["BlockTs"] = "block_ts";
    IssueColumns["VaultId"] = "vault_id";
    IssueColumns["BtcAddress"] = "btc_address";
    IssueColumns["Cancelled"] = "cancelled";
    IssueColumns["Executed"] = "executed";
})(IssueColumns = exports.IssueColumns || (exports.IssueColumns = {}));
/**
 *
 * @export
 * @enum {string}
 */
var RedeemColumns;
(function (RedeemColumns) {
    RedeemColumns["RedeemId"] = "redeem_id";
    RedeemColumns["Requester"] = "requester";
    RedeemColumns["AmountPolkaBtc"] = "amount_polka_btc";
    RedeemColumns["FeePolkabtc"] = "fee_polkabtc";
    RedeemColumns["DotPremium"] = "dot_premium";
    RedeemColumns["BlockNumber"] = "block_number";
    RedeemColumns["BlockTs"] = "block_ts";
    RedeemColumns["Reimbursed"] = "reimbursed";
    RedeemColumns["VaultId"] = "vault_id";
    RedeemColumns["BtcAddress"] = "btc_address";
    RedeemColumns["Cancelled"] = "cancelled";
    RedeemColumns["Executed"] = "executed";
})(RedeemColumns = exports.RedeemColumns || (exports.RedeemColumns = {}));
/**
 *
 * @export
 * @enum {string}
 */
var RelayerChallengeColumns;
(function (RelayerChallengeColumns) {
    RelayerChallengeColumns["RelayerId"] = "relayer_id";
    RelayerChallengeColumns["BlockNumber"] = "block_number";
    RelayerChallengeColumns["Stake"] = "stake";
    RelayerChallengeColumns["Deregistered"] = "deregistered";
    RelayerChallengeColumns["Slashed"] = "slashed";
    RelayerChallengeColumns["Bonded"] = "bonded";
    RelayerChallengeColumns["LifetimeSlaChange"] = "lifetime_sla_change";
})(RelayerChallengeColumns = exports.RelayerChallengeColumns || (exports.RelayerChallengeColumns = {}));
/**
 *
 * @export
 * @enum {string}
 */
var StatusUpdateColumns;
(function (StatusUpdateColumns) {
    StatusUpdateColumns["UpdateId"] = "update_id";
    StatusUpdateColumns["BlockTs"] = "block_ts";
    StatusUpdateColumns["BlockNumber"] = "block_number";
    StatusUpdateColumns["NewStatus"] = "new_status";
    StatusUpdateColumns["AddError"] = "add_error";
    StatusUpdateColumns["RemoveError"] = "remove_error";
    StatusUpdateColumns["BtcBlockHash"] = "btc_block_hash";
    StatusUpdateColumns["Yeas"] = "yeas";
    StatusUpdateColumns["Nays"] = "nays";
    StatusUpdateColumns["Executed"] = "executed";
    StatusUpdateColumns["Rejected"] = "rejected";
    StatusUpdateColumns["Forced"] = "forced";
})(StatusUpdateColumns = exports.StatusUpdateColumns || (exports.StatusUpdateColumns = {}));
/**
 *
 * @export
 * @enum {string}
 */
var VaultChallengeColumns;
(function (VaultChallengeColumns) {
    VaultChallengeColumns["VaultId"] = "vault_id";
    VaultChallengeColumns["BlockNumber"] = "block_number";
    VaultChallengeColumns["Collateral"] = "collateral";
    VaultChallengeColumns["RequestIssueCount"] = "request_issue_count";
    VaultChallengeColumns["ExecuteIssueCount"] = "execute_issue_count";
    VaultChallengeColumns["RequestRedeemCount"] = "request_redeem_count";
    VaultChallengeColumns["ExecuteRedeemCount"] = "execute_redeem_count";
    VaultChallengeColumns["CancelRedeemCount"] = "cancel_redeem_count";
    VaultChallengeColumns["LifetimeSlaChange"] = "lifetime_sla_change";
})(VaultChallengeColumns = exports.VaultChallengeColumns || (exports.VaultChallengeColumns = {}));
/**
 *
 * @export
 * @enum {string}
 */
var VaultColumns;
(function (VaultColumns) {
    VaultColumns["VaultId"] = "vault_id";
    VaultColumns["BlockNumber"] = "block_number";
    VaultColumns["Collateral"] = "collateral";
    VaultColumns["LockedBtc"] = "locked_btc";
    VaultColumns["PendingBtc"] = "pending_btc";
    VaultColumns["CommittedTheft"] = "committed_theft";
    VaultColumns["Liquidated"] = "liquidated";
    VaultColumns["BannedUntil"] = "banned_until";
})(VaultColumns = exports.VaultColumns || (exports.VaultColumns = {}));
/**
 * StatsApi - axios parameter creator
 * @export
 */
var StatsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Retrieves a paged list of BTC blocks submitted to the relay.
         * @param {number} [page]
         * @param {number} [perPage]
         * @param {BlockColumns} [sortBy]
         * @param {boolean} [sortAsc]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBlocks: function (page, perPage, sortBy, sortAsc, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, queryParameters, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/blocks";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (page !== undefined) {
                        localVarQueryParameter['page'] = page;
                    }
                    if (perPage !== undefined) {
                        localVarQueryParameter['perPage'] = perPage;
                    }
                    if (sortBy !== undefined) {
                        localVarQueryParameter['sortBy'] = sortBy;
                    }
                    if (sortAsc !== undefined) {
                        localVarQueryParameter['sortAsc'] = sortAsc;
                    }
                    queryParameters = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        queryParameters.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        queryParameters.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBtcConfirmations: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, queryParameters, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/constants/btcConfirmations";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    queryParameters = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        queryParameters.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        queryParameters.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @param {number} slaSince
         * @param {number} [page]
         * @param {number} [perPage]
         * @param {VaultChallengeColumns} [sortBy]
         * @param {boolean} [sortAsc]
         * @param {Array<FilterVaultChallengeColumns>} [filterVaultChallengeColumns]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChallengeFilteredVaults: function (slaSince, page, perPage, sortBy, sortAsc, filterVaultChallengeColumns, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, queryParameters, key, key, headersFromBaseOptions, nonString, needsSerialization;
                return __generator(this, function (_a) {
                    // verify required parameter 'slaSince' is not null or undefined
                    if (slaSince === null || slaSince === undefined) {
                        throw new base_1.RequiredError('slaSince', 'Required parameter slaSince was null or undefined when calling getChallengeFilteredVaults.');
                    }
                    localVarPath = "/vaults/challengeVaultList";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (slaSince !== undefined) {
                        localVarQueryParameter['slaSince'] = slaSince;
                    }
                    if (page !== undefined) {
                        localVarQueryParameter['page'] = page;
                    }
                    if (perPage !== undefined) {
                        localVarQueryParameter['perPage'] = perPage;
                    }
                    if (sortBy !== undefined) {
                        localVarQueryParameter['sortBy'] = sortBy;
                    }
                    if (sortAsc !== undefined) {
                        localVarQueryParameter['sortAsc'] = sortAsc;
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    queryParameters = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        queryParameters.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        queryParameters.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    nonString = typeof filterVaultChallengeColumns !== 'string';
                    needsSerialization = nonString && configuration && configuration.isJsonMime
                        ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                        : nonString;
                    localVarRequestOptions.data = needsSerialization
                        ? JSON.stringify(filterVaultChallengeColumns !== undefined ? filterVaultChallengeColumns : {})
                        : (filterVaultChallengeColumns || "");
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Retrieves a paged list of vaults, with numbers of issue and redeem requests, and the unbounded sum SLA scores after a given cutoff.
         * @param {number} slaSince A UNIX timestamp starting from which the SLA score will be summed.
         * @param {number} [page]
         * @param {number} [perPage]
         * @param {VaultChallengeColumns} [sortBy]
         * @param {boolean} [sortAsc]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChallengeVaults: function (slaSince, page, perPage, sortBy, sortAsc, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, queryParameters, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'slaSince' is not null or undefined
                    if (slaSince === null || slaSince === undefined) {
                        throw new base_1.RequiredError('slaSince', 'Required parameter slaSince was null or undefined when calling getChallengeVaults.');
                    }
                    localVarPath = "/vaults/challengeVaultList";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (slaSince !== undefined) {
                        localVarQueryParameter['slaSince'] = slaSince;
                    }
                    if (page !== undefined) {
                        localVarQueryParameter['page'] = page;
                    }
                    if (perPage !== undefined) {
                        localVarQueryParameter['perPage'] = perPage;
                    }
                    if (sortBy !== undefined) {
                        localVarQueryParameter['sortBy'] = sortBy;
                    }
                    if (sortAsc !== undefined) {
                        localVarQueryParameter['sortAsc'] = sortAsc;
                    }
                    queryParameters = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        queryParameters.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        queryParameters.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDustValue: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, queryParameters, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/constants/dustValue";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    queryParameters = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        queryParameters.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        queryParameters.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @param {number} [page]
         * @param {number} [perPage]
         * @param {IssueColumns} [sortBy]
         * @param {boolean} [sortAsc]
         * @param {BtcNetworkName} [network]
         * @param {Array<FilterIssueColumns>} [filterIssueColumns]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilteredIssues: function (page, perPage, sortBy, sortAsc, network, filterIssueColumns, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, queryParameters, key, key, headersFromBaseOptions, nonString, needsSerialization;
                return __generator(this, function (_a) {
                    localVarPath = "/issues";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (page !== undefined) {
                        localVarQueryParameter['page'] = page;
                    }
                    if (perPage !== undefined) {
                        localVarQueryParameter['perPage'] = perPage;
                    }
                    if (sortBy !== undefined) {
                        localVarQueryParameter['sortBy'] = sortBy;
                    }
                    if (sortAsc !== undefined) {
                        localVarQueryParameter['sortAsc'] = sortAsc;
                    }
                    if (network !== undefined) {
                        localVarQueryParameter['network'] = network;
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    queryParameters = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        queryParameters.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        queryParameters.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    nonString = typeof filterIssueColumns !== 'string';
                    needsSerialization = nonString && configuration && configuration.isJsonMime
                        ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                        : nonString;
                    localVarRequestOptions.data = needsSerialization
                        ? JSON.stringify(filterIssueColumns !== undefined ? filterIssueColumns : {})
                        : (filterIssueColumns || "");
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @param {number} [page]
         * @param {number} [perPage]
         * @param {StatusUpdateColumns} [sortBy]
         * @param {boolean} [sortAsc]
         * @param {Array<FilterStatusUpdateColumns>} [filterStatusUpdateColumns]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilteredParachainStatusUpdates: function (page, perPage, sortBy, sortAsc, filterStatusUpdateColumns, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, queryParameters, key, key, headersFromBaseOptions, nonString, needsSerialization;
                return __generator(this, function (_a) {
                    localVarPath = "/statusUpdates";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (page !== undefined) {
                        localVarQueryParameter['page'] = page;
                    }
                    if (perPage !== undefined) {
                        localVarQueryParameter['perPage'] = perPage;
                    }
                    if (sortBy !== undefined) {
                        localVarQueryParameter['sortBy'] = sortBy;
                    }
                    if (sortAsc !== undefined) {
                        localVarQueryParameter['sortAsc'] = sortAsc;
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    queryParameters = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        queryParameters.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        queryParameters.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    nonString = typeof filterStatusUpdateColumns !== 'string';
                    needsSerialization = nonString && configuration && configuration.isJsonMime
                        ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                        : nonString;
                    localVarRequestOptions.data = needsSerialization
                        ? JSON.stringify(filterStatusUpdateColumns !== undefined ? filterStatusUpdateColumns : {})
                        : (filterStatusUpdateColumns || "");
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @param {number} [page]
         * @param {number} [perPage]
         * @param {RedeemColumns} [sortBy]
         * @param {boolean} [sortAsc]
         * @param {BtcNetworkName} [network]
         * @param {Array<FilterRedeemColumns>} [filterRedeemColumns]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilteredRedeems: function (page, perPage, sortBy, sortAsc, network, filterRedeemColumns, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, queryParameters, key, key, headersFromBaseOptions, nonString, needsSerialization;
                return __generator(this, function (_a) {
                    localVarPath = "/redeems";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (page !== undefined) {
                        localVarQueryParameter['page'] = page;
                    }
                    if (perPage !== undefined) {
                        localVarQueryParameter['perPage'] = perPage;
                    }
                    if (sortBy !== undefined) {
                        localVarQueryParameter['sortBy'] = sortBy;
                    }
                    if (sortAsc !== undefined) {
                        localVarQueryParameter['sortAsc'] = sortAsc;
                    }
                    if (network !== undefined) {
                        localVarQueryParameter['network'] = network;
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    queryParameters = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        queryParameters.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        queryParameters.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    nonString = typeof filterRedeemColumns !== 'string';
                    needsSerialization = nonString && configuration && configuration.isJsonMime
                        ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                        : nonString;
                    localVarRequestOptions.data = needsSerialization
                        ? JSON.stringify(filterRedeemColumns !== undefined ? filterRedeemColumns : {})
                        : (filterRedeemColumns || "");
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @param {number} slaSince
         * @param {number} [page]
         * @param {number} [perPage]
         * @param {RelayerChallengeColumns} [sortBy]
         * @param {boolean} [sortAsc]
         * @param {Array<FilterRelayerChallengeColumns>} [filterRelayerChallengeColumns]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilteredRelayers: function (slaSince, page, perPage, sortBy, sortAsc, filterRelayerChallengeColumns, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, queryParameters, key, key, headersFromBaseOptions, nonString, needsSerialization;
                return __generator(this, function (_a) {
                    // verify required parameter 'slaSince' is not null or undefined
                    if (slaSince === null || slaSince === undefined) {
                        throw new base_1.RequiredError('slaSince', 'Required parameter slaSince was null or undefined when calling getFilteredRelayers.');
                    }
                    localVarPath = "/relayers";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (slaSince !== undefined) {
                        localVarQueryParameter['slaSince'] = slaSince;
                    }
                    if (page !== undefined) {
                        localVarQueryParameter['page'] = page;
                    }
                    if (perPage !== undefined) {
                        localVarQueryParameter['perPage'] = perPage;
                    }
                    if (sortBy !== undefined) {
                        localVarQueryParameter['sortBy'] = sortBy;
                    }
                    if (sortAsc !== undefined) {
                        localVarQueryParameter['sortAsc'] = sortAsc;
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    queryParameters = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        queryParameters.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        queryParameters.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    nonString = typeof filterRelayerChallengeColumns !== 'string';
                    needsSerialization = nonString && configuration && configuration.isJsonMime
                        ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                        : nonString;
                    localVarRequestOptions.data = needsSerialization
                        ? JSON.stringify(filterRelayerChallengeColumns !== undefined ? filterRelayerChallengeColumns : {})
                        : (filterRelayerChallengeColumns || "");
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @param {Array<FilterIssueColumns>} [filterIssueColumns]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilteredTotalIssues: function (filterIssueColumns, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, queryParameters, key, key, headersFromBaseOptions, nonString, needsSerialization;
                return __generator(this, function (_a) {
                    localVarPath = "/issues/total";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    queryParameters = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        queryParameters.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        queryParameters.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    nonString = typeof filterIssueColumns !== 'string';
                    needsSerialization = nonString && configuration && configuration.isJsonMime
                        ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                        : nonString;
                    localVarRequestOptions.data = needsSerialization
                        ? JSON.stringify(filterIssueColumns !== undefined ? filterIssueColumns : {})
                        : (filterIssueColumns || "");
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @param {Array<FilterRedeemColumns>} [filterRedeemColumns]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilteredTotalRedeems: function (filterRedeemColumns, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, queryParameters, key, key, headersFromBaseOptions, nonString, needsSerialization;
                return __generator(this, function (_a) {
                    localVarPath = "/redeems/total";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    queryParameters = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        queryParameters.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        queryParameters.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    nonString = typeof filterRedeemColumns !== 'string';
                    needsSerialization = nonString && configuration && configuration.isJsonMime
                        ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                        : nonString;
                    localVarRequestOptions.data = needsSerialization
                        ? JSON.stringify(filterRedeemColumns !== undefined ? filterRedeemColumns : {})
                        : (filterRedeemColumns || "");
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @param {number} [page]
         * @param {number} [perPage]
         * @param {VaultColumns} [sortBy]
         * @param {boolean} [sortAsc]
         * @param {Array<FilterVaultColumns>} [filterVaultColumns]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilteredVaults: function (page, perPage, sortBy, sortAsc, filterVaultColumns, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, queryParameters, key, key, headersFromBaseOptions, nonString, needsSerialization;
                return __generator(this, function (_a) {
                    localVarPath = "/vaults";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (page !== undefined) {
                        localVarQueryParameter['page'] = page;
                    }
                    if (perPage !== undefined) {
                        localVarQueryParameter['perPage'] = perPage;
                    }
                    if (sortBy !== undefined) {
                        localVarQueryParameter['sortBy'] = sortBy;
                    }
                    if (sortAsc !== undefined) {
                        localVarQueryParameter['sortAsc'] = sortAsc;
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    queryParameters = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        queryParameters.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        queryParameters.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    nonString = typeof filterVaultColumns !== 'string';
                    needsSerialization = nonString && configuration && configuration.isJsonMime
                        ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                        : nonString;
                    localVarRequestOptions.data = needsSerialization
                        ? JSON.stringify(filterVaultColumns !== undefined ? filterVaultColumns : {})
                        : (filterVaultColumns || "");
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFullReport: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, queryParameters, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/reports";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    queryParameters = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        queryParameters.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        queryParameters.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Retrieves the latest btc block submitted to BTCRelay.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHighestBTCBlock: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, queryParameters, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/blocks/highestBlock";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    queryParameters = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        queryParameters.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        queryParameters.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIssueFee: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, queryParameters, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/constants/issueFee";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    queryParameters = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        queryParameters.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        queryParameters.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIssueGriefingCollateral: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, queryParameters, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/constants/issueGriefingCollateral";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    queryParameters = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        queryParameters.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        queryParameters.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIssuePeriod: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, queryParameters, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/constants/issuePeriod";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    queryParameters = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        queryParameters.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        queryParameters.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIssueStats: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, queryParameters, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/reports/issueStats";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    queryParameters = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        queryParameters.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        queryParameters.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Retrieves a paged list of issue requests.
         * @param {number} [page]
         * @param {number} [perPage]
         * @param {IssueColumns} [sortBy]
         * @param {boolean} [sortAsc]
         * @param {BtcNetworkName} [network] the BTC network used for issue transactions; necessary to correctly decode vault addresses and transaction IDs.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIssues: function (page, perPage, sortBy, sortAsc, network, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, queryParameters, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/issues";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (page !== undefined) {
                        localVarQueryParameter['page'] = page;
                    }
                    if (perPage !== undefined) {
                        localVarQueryParameter['perPage'] = perPage;
                    }
                    if (sortBy !== undefined) {
                        localVarQueryParameter['sortBy'] = sortBy;
                    }
                    if (sortAsc !== undefined) {
                        localVarQueryParameter['sortAsc'] = sortAsc;
                    }
                    if (network !== undefined) {
                        localVarQueryParameter['network'] = network;
                    }
                    queryParameters = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        queryParameters.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        queryParameters.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Retrieves the latest update (from any oracle).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestSubmission: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, queryParameters, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/oracle/latest";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    queryParameters = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        queryParameters.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        queryParameters.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Retrieves the last update from each of the oracles in the system.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestSubmissionForEachOracle: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, queryParameters, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/oracle/submissions";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    queryParameters = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        queryParameters.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        queryParameters.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParachainConstants: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, queryParameters, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/constants";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    queryParameters = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        queryParameters.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        queryParameters.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Retrieves a paged list of parachain status updates.
         * @param {number} [page]
         * @param {number} [perPage]
         * @param {StatusUpdateColumns} [sortBy]
         * @param {boolean} [sortAsc]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParachainStatusUpdates: function (page, perPage, sortBy, sortAsc, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, queryParameters, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/statusUpdates";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (page !== undefined) {
                        localVarQueryParameter['page'] = page;
                    }
                    if (perPage !== undefined) {
                        localVarQueryParameter['perPage'] = perPage;
                    }
                    if (sortBy !== undefined) {
                        localVarQueryParameter['sortBy'] = sortBy;
                    }
                    if (sortAsc !== undefined) {
                        localVarQueryParameter['sortAsc'] = sortAsc;
                    }
                    queryParameters = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        queryParameters.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        queryParameters.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPremiumRedeemFee: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, queryParameters, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/constants/premiumRedeemFee";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    queryParameters = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        queryParameters.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        queryParameters.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Gets the total number of collateral locked at midnight for the last several days
         * @param {number} [daysBack] number of days (starting from the next midnight) to give datapoints for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecentDailyCollateralLocked: function (daysBack, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, queryParameters, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/vaults/recentDailyCollateral";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (daysBack !== undefined) {
                        localVarQueryParameter['daysBack'] = daysBack;
                    }
                    queryParameters = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        queryParameters.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        queryParameters.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Gets the total amount issued before midnight for the last several days
         * @param {number} [daysBack] number of days (starting from the next midnight) to give datapoints for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecentDailyIssues: function (daysBack, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, queryParameters, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/issues/recentDaily";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (daysBack !== undefined) {
                        localVarQueryParameter['daysBack'] = daysBack;
                    }
                    queryParameters = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        queryParameters.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        queryParameters.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Gets the total amount redeemed before midnight for the last several days
         * @param {number} [daysBack] number of days (starting from the next midnight) to give datapoints for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecentDailyRedeems: function (daysBack, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, queryParameters, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/redeems/recentDaily";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (daysBack !== undefined) {
                        localVarQueryParameter['daysBack'] = daysBack;
                    }
                    queryParameters = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        queryParameters.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        queryParameters.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Gets the total number of relayers registered at midnight for the last several days Does not take into account online status, only registration.
         * @param {number} [daysBack] number of days (starting from the next midnight) to give datapoints for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecentDailyRelayerCounts: function (daysBack, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, queryParameters, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/relayers/recentDailyCounts";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (daysBack !== undefined) {
                        localVarQueryParameter['daysBack'] = daysBack;
                    }
                    queryParameters = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        queryParameters.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        queryParameters.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Gets the total number of vaults registered at midnight for the last several days Does not take into account online status, only registration.
         * @param {number} [daysBack] number of days (starting from the next midnight) to give datapoints for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecentDailyVaultCounts: function (daysBack, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, queryParameters, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/vaults/recentDailyCounts";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (daysBack !== undefined) {
                        localVarQueryParameter['daysBack'] = daysBack;
                    }
                    queryParameters = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        queryParameters.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        queryParameters.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecentVaultCollateralisatonRates: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, queryParameters, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/reports/recentVaultCollateralisations";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    queryParameters = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        queryParameters.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        queryParameters.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRedeemStats: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, queryParameters, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/reports/redeemStats";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    queryParameters = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        queryParameters.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        queryParameters.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Retrieves a paged list of redeem requests.
         * @param {number} [page]
         * @param {number} [perPage]
         * @param {RedeemColumns} [sortBy]
         * @param {boolean} [sortAsc]
         * @param {BtcNetworkName} [network] the BTC network used for redeem transactions; necessary to correctly decode vault addresses and transaction IDs.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRedeems: function (page, perPage, sortBy, sortAsc, network, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, queryParameters, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/redeems";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (page !== undefined) {
                        localVarQueryParameter['page'] = page;
                    }
                    if (perPage !== undefined) {
                        localVarQueryParameter['perPage'] = perPage;
                    }
                    if (sortBy !== undefined) {
                        localVarQueryParameter['sortBy'] = sortBy;
                    }
                    if (sortAsc !== undefined) {
                        localVarQueryParameter['sortAsc'] = sortAsc;
                    }
                    if (network !== undefined) {
                        localVarQueryParameter['network'] = network;
                    }
                    queryParameters = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        queryParameters.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        queryParameters.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Retrieves a paged list of relayers, along with the unbounded sum SLA scores after a given cutoff.
         * @param {number} slaSince A UNIX timestamp starting from which the SLA score will be summed.
         * @param {number} [page]
         * @param {number} [perPage]
         * @param {RelayerChallengeColumns} [sortBy]
         * @param {boolean} [sortAsc]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelayers: function (slaSince, page, perPage, sortBy, sortAsc, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, queryParameters, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'slaSince' is not null or undefined
                    if (slaSince === null || slaSince === undefined) {
                        throw new base_1.RequiredError('slaSince', 'Required parameter slaSince was null or undefined when calling getRelayers.');
                    }
                    localVarPath = "/relayers";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (slaSince !== undefined) {
                        localVarQueryParameter['slaSince'] = slaSince;
                    }
                    if (page !== undefined) {
                        localVarQueryParameter['page'] = page;
                    }
                    if (perPage !== undefined) {
                        localVarQueryParameter['perPage'] = perPage;
                    }
                    if (sortBy !== undefined) {
                        localVarQueryParameter['sortBy'] = sortBy;
                    }
                    if (sortAsc !== undefined) {
                        localVarQueryParameter['sortAsc'] = sortAsc;
                    }
                    queryParameters = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        queryParameters.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        queryParameters.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReplaceStats: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, queryParameters, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/reports/replaceStats";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    queryParameters = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        queryParameters.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        queryParameters.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSecureCollateralThreshold: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, queryParameters, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/constants/secureCollateralThreshold";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    queryParameters = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        queryParameters.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        queryParameters.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatusUpdateStats: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, queryParameters, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/reports/statusVotingStats";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    queryParameters = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        queryParameters.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        queryParameters.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Returns the total count of issue requests (regardless of execution).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTotalIssues: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, queryParameters, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/issues/total";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    queryParameters = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        queryParameters.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        queryParameters.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Gets the total count of status updates submitted (regardless of voting status).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTotalParachainStatusUpdates: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, queryParameters, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/statusUpdates/total";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    queryParameters = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        queryParameters.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        queryParameters.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Retrieves the total value of polkaBTC successfully redeemed (all time).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTotalRedeemedAmount: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, queryParameters, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/redeems/totalAmount";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    queryParameters = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        queryParameters.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        queryParameters.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Returns the total count of redeem requests (regardless of execution).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTotalRedeems: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, queryParameters, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/redeems/total";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    queryParameters = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        queryParameters.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        queryParameters.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Retrieves the total amount of blocks submitted to BTCRelay.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTotalRelayedBlocksCount: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, queryParameters, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/blocks/count";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    queryParameters = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        queryParameters.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        queryParameters.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Returns the total count of successfully executed issues.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTotalSuccessfulIssues: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, queryParameters, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/issues/totalSuccessful";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    queryParameters = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        queryParameters.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        queryParameters.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Returns the total count of successfully executed redeems.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTotalSuccessfulRedeems: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, queryParameters, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/redeems/totalSuccessful";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    queryParameters = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        queryParameters.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        queryParameters.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Retrieves the total value locked (i.e. polkaBTC issued - redeemed), snapshotted at the given timestamps.
         * @param {Array<number>} days an array of timestamps, in miliseconds since the UNIX epoch
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTvlForTimestamps: function (days, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, queryParameters, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'days' is not null or undefined
                    if (days === null || days === undefined) {
                        throw new base_1.RequiredError('days', 'Required parameter days was null or undefined when calling getTvlForTimestamps.');
                    }
                    localVarPath = "/issues/tvlPerTimestamp";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (days) {
                        localVarQueryParameter['days'] = days;
                    }
                    queryParameters = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        queryParameters.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        queryParameters.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserCountStats: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, queryParameters, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/reports/userStats";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    queryParameters = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        queryParameters.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        queryParameters.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @param {number} timestamp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVaultCollateralisationStatsAtTime: function (timestamp, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, queryParameters, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'timestamp' is not null or undefined
                    if (timestamp === null || timestamp === undefined) {
                        throw new base_1.RequiredError('timestamp', 'Required parameter timestamp was null or undefined when calling getVaultCollateralisationStatsAtTime.');
                    }
                    localVarPath = "/reports/vaultCollateralStats";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (timestamp !== undefined) {
                        localVarQueryParameter['timestamp'] = timestamp;
                    }
                    queryParameters = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        queryParameters.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        queryParameters.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVaultPunishmentFee: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, queryParameters, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/constants/vaultPunishmentFee";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    queryParameters = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        queryParameters.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        queryParameters.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVaultStats: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, queryParameters, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/reports/vaultStats";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    queryParameters = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        queryParameters.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        queryParameters.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Retrieves a paged list of vaults, with all dashboard stats (collateral, locked BTC, etc.)
         * @param {number} [page]
         * @param {number} [perPage]
         * @param {VaultColumns} [sortBy]
         * @param {boolean} [sortAsc]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVaults: function (page, perPage, sortBy, sortAsc, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, queryParameters, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/vaults";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (page !== undefined) {
                        localVarQueryParameter['page'] = page;
                    }
                    if (perPage !== undefined) {
                        localVarQueryParameter['perPage'] = perPage;
                    }
                    if (sortBy !== undefined) {
                        localVarQueryParameter['sortBy'] = sortBy;
                    }
                    if (sortAsc !== undefined) {
                        localVarQueryParameter['sortAsc'] = sortAsc;
                    }
                    queryParameters = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        queryParameters.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        queryParameters.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Returns a list of relayers with a minimum SLA track record, as specified by the parameters.
         * @param {number} [minSla] the SLA theshold to consider
         * @param {number} [minConsecutivePeriod] the duration above which the relayer must have had SLA above minSLA (in miliseconds)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRelayersWithTrackRecord: function (minSla, minConsecutivePeriod, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, queryParameters, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/relayers/relayersWithTrackRecord";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (minSla !== undefined) {
                        localVarQueryParameter['minSla'] = minSla;
                    }
                    if (minConsecutivePeriod !== undefined) {
                        localVarQueryParameter['minConsecutivePeriod'] = minConsecutivePeriod;
                    }
                    queryParameters = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        queryParameters.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        queryParameters.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions
                        }];
                });
            });
        },
        /**
         * Returns a list of vaults with a minimum SLA track record, as specified by the parameters.
         * @param {number} [minSla] the SLA theshold to consider
         * @param {number} [minConsecutivePeriod] the duration above which the relayer must have had SLA above minSLA (in miliseconds)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listVaultsWithTrackRecord: function (minSla, minConsecutivePeriod, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, queryParameters, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/vaults/vaultsWithTrackRecord";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (minSla !== undefined) {
                        localVarQueryParameter['minSla'] = minSla;
                    }
                    if (minConsecutivePeriod !== undefined) {
                        localVarQueryParameter['minConsecutivePeriod'] = minConsecutivePeriod;
                    }
                    queryParameters = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        queryParameters.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        queryParameters.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions
                        }];
                });
            });
        }
    };
};
exports.StatsApiAxiosParamCreator = StatsApiAxiosParamCreator;
/**
 * StatsApi - functional programming interface
 * @export
 */
var StatsApiFp = function (configuration) {
    return {
        /**
         * Retrieves a paged list of BTC blocks submitted to the relay.
         * @param {number} [page]
         * @param {number} [perPage]
         * @param {BlockColumns} [sortBy]
         * @param {boolean} [sortAsc]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBlocks: function (page, perPage, sortBy, sortAsc, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.StatsApiAxiosParamCreator(configuration).getBlocks(page, perPage, sortBy, sortAsc, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1["default"]; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBtcConfirmations: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.StatsApiAxiosParamCreator(configuration).getBtcConfirmations(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1["default"]; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} slaSince
         * @param {number} [page]
         * @param {number} [perPage]
         * @param {VaultChallengeColumns} [sortBy]
         * @param {boolean} [sortAsc]
         * @param {Array<FilterVaultChallengeColumns>} [filterVaultChallengeColumns]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChallengeFilteredVaults: function (slaSince, page, perPage, sortBy, sortAsc, filterVaultChallengeColumns, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.StatsApiAxiosParamCreator(configuration).getChallengeFilteredVaults(slaSince, page, perPage, sortBy, sortAsc, filterVaultChallengeColumns, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1["default"]; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Retrieves a paged list of vaults, with numbers of issue and redeem requests, and the unbounded sum SLA scores after a given cutoff.
         * @param {number} slaSince A UNIX timestamp starting from which the SLA score will be summed.
         * @param {number} [page]
         * @param {number} [perPage]
         * @param {VaultChallengeColumns} [sortBy]
         * @param {boolean} [sortAsc]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChallengeVaults: function (slaSince, page, perPage, sortBy, sortAsc, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.StatsApiAxiosParamCreator(configuration).getChallengeVaults(slaSince, page, perPage, sortBy, sortAsc, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1["default"]; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDustValue: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.StatsApiAxiosParamCreator(configuration).getDustValue(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1["default"]; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} [page]
         * @param {number} [perPage]
         * @param {IssueColumns} [sortBy]
         * @param {boolean} [sortAsc]
         * @param {BtcNetworkName} [network]
         * @param {Array<FilterIssueColumns>} [filterIssueColumns]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilteredIssues: function (page, perPage, sortBy, sortAsc, network, filterIssueColumns, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.StatsApiAxiosParamCreator(configuration).getFilteredIssues(page, perPage, sortBy, sortAsc, network, filterIssueColumns, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1["default"]; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} [page]
         * @param {number} [perPage]
         * @param {StatusUpdateColumns} [sortBy]
         * @param {boolean} [sortAsc]
         * @param {Array<FilterStatusUpdateColumns>} [filterStatusUpdateColumns]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilteredParachainStatusUpdates: function (page, perPage, sortBy, sortAsc, filterStatusUpdateColumns, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.StatsApiAxiosParamCreator(configuration).getFilteredParachainStatusUpdates(page, perPage, sortBy, sortAsc, filterStatusUpdateColumns, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1["default"]; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} [page]
         * @param {number} [perPage]
         * @param {RedeemColumns} [sortBy]
         * @param {boolean} [sortAsc]
         * @param {BtcNetworkName} [network]
         * @param {Array<FilterRedeemColumns>} [filterRedeemColumns]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilteredRedeems: function (page, perPage, sortBy, sortAsc, network, filterRedeemColumns, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.StatsApiAxiosParamCreator(configuration).getFilteredRedeems(page, perPage, sortBy, sortAsc, network, filterRedeemColumns, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1["default"]; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} slaSince
         * @param {number} [page]
         * @param {number} [perPage]
         * @param {RelayerChallengeColumns} [sortBy]
         * @param {boolean} [sortAsc]
         * @param {Array<FilterRelayerChallengeColumns>} [filterRelayerChallengeColumns]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilteredRelayers: function (slaSince, page, perPage, sortBy, sortAsc, filterRelayerChallengeColumns, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.StatsApiAxiosParamCreator(configuration).getFilteredRelayers(slaSince, page, perPage, sortBy, sortAsc, filterRelayerChallengeColumns, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1["default"]; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {Array<FilterIssueColumns>} [filterIssueColumns]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilteredTotalIssues: function (filterIssueColumns, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.StatsApiAxiosParamCreator(configuration).getFilteredTotalIssues(filterIssueColumns, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1["default"]; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {Array<FilterRedeemColumns>} [filterRedeemColumns]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilteredTotalRedeems: function (filterRedeemColumns, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.StatsApiAxiosParamCreator(configuration).getFilteredTotalRedeems(filterRedeemColumns, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1["default"]; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} [page]
         * @param {number} [perPage]
         * @param {VaultColumns} [sortBy]
         * @param {boolean} [sortAsc]
         * @param {Array<FilterVaultColumns>} [filterVaultColumns]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilteredVaults: function (page, perPage, sortBy, sortAsc, filterVaultColumns, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.StatsApiAxiosParamCreator(configuration).getFilteredVaults(page, perPage, sortBy, sortAsc, filterVaultColumns, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1["default"]; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFullReport: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.StatsApiAxiosParamCreator(configuration).getFullReport(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1["default"]; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Retrieves the latest btc block submitted to BTCRelay.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHighestBTCBlock: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.StatsApiAxiosParamCreator(configuration).getHighestBTCBlock(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1["default"]; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIssueFee: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.StatsApiAxiosParamCreator(configuration).getIssueFee(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1["default"]; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIssueGriefingCollateral: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.StatsApiAxiosParamCreator(configuration).getIssueGriefingCollateral(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1["default"]; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIssuePeriod: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.StatsApiAxiosParamCreator(configuration).getIssuePeriod(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1["default"]; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIssueStats: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.StatsApiAxiosParamCreator(configuration).getIssueStats(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1["default"]; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Retrieves a paged list of issue requests.
         * @param {number} [page]
         * @param {number} [perPage]
         * @param {IssueColumns} [sortBy]
         * @param {boolean} [sortAsc]
         * @param {BtcNetworkName} [network] the BTC network used for issue transactions; necessary to correctly decode vault addresses and transaction IDs.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIssues: function (page, perPage, sortBy, sortAsc, network, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.StatsApiAxiosParamCreator(configuration).getIssues(page, perPage, sortBy, sortAsc, network, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1["default"]; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Retrieves the latest update (from any oracle).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestSubmission: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.StatsApiAxiosParamCreator(configuration).getLatestSubmission(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1["default"]; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Retrieves the last update from each of the oracles in the system.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestSubmissionForEachOracle: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.StatsApiAxiosParamCreator(configuration).getLatestSubmissionForEachOracle(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1["default"]; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParachainConstants: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.StatsApiAxiosParamCreator(configuration).getParachainConstants(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1["default"]; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Retrieves a paged list of parachain status updates.
         * @param {number} [page]
         * @param {number} [perPage]
         * @param {StatusUpdateColumns} [sortBy]
         * @param {boolean} [sortAsc]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParachainStatusUpdates: function (page, perPage, sortBy, sortAsc, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.StatsApiAxiosParamCreator(configuration).getParachainStatusUpdates(page, perPage, sortBy, sortAsc, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1["default"]; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPremiumRedeemFee: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.StatsApiAxiosParamCreator(configuration).getPremiumRedeemFee(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1["default"]; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Gets the total number of collateral locked at midnight for the last several days
         * @param {number} [daysBack] number of days (starting from the next midnight) to give datapoints for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecentDailyCollateralLocked: function (daysBack, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.StatsApiAxiosParamCreator(configuration).getRecentDailyCollateralLocked(daysBack, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1["default"]; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Gets the total amount issued before midnight for the last several days
         * @param {number} [daysBack] number of days (starting from the next midnight) to give datapoints for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecentDailyIssues: function (daysBack, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.StatsApiAxiosParamCreator(configuration).getRecentDailyIssues(daysBack, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1["default"]; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Gets the total amount redeemed before midnight for the last several days
         * @param {number} [daysBack] number of days (starting from the next midnight) to give datapoints for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecentDailyRedeems: function (daysBack, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.StatsApiAxiosParamCreator(configuration).getRecentDailyRedeems(daysBack, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1["default"]; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Gets the total number of relayers registered at midnight for the last several days Does not take into account online status, only registration.
         * @param {number} [daysBack] number of days (starting from the next midnight) to give datapoints for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecentDailyRelayerCounts: function (daysBack, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.StatsApiAxiosParamCreator(configuration).getRecentDailyRelayerCounts(daysBack, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1["default"]; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Gets the total number of vaults registered at midnight for the last several days Does not take into account online status, only registration.
         * @param {number} [daysBack] number of days (starting from the next midnight) to give datapoints for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecentDailyVaultCounts: function (daysBack, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.StatsApiAxiosParamCreator(configuration).getRecentDailyVaultCounts(daysBack, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1["default"]; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecentVaultCollateralisatonRates: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.StatsApiAxiosParamCreator(configuration).getRecentVaultCollateralisatonRates(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1["default"]; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRedeemStats: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.StatsApiAxiosParamCreator(configuration).getRedeemStats(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1["default"]; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Retrieves a paged list of redeem requests.
         * @param {number} [page]
         * @param {number} [perPage]
         * @param {RedeemColumns} [sortBy]
         * @param {boolean} [sortAsc]
         * @param {BtcNetworkName} [network] the BTC network used for redeem transactions; necessary to correctly decode vault addresses and transaction IDs.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRedeems: function (page, perPage, sortBy, sortAsc, network, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.StatsApiAxiosParamCreator(configuration).getRedeems(page, perPage, sortBy, sortAsc, network, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1["default"]; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Retrieves a paged list of relayers, along with the unbounded sum SLA scores after a given cutoff.
         * @param {number} slaSince A UNIX timestamp starting from which the SLA score will be summed.
         * @param {number} [page]
         * @param {number} [perPage]
         * @param {RelayerChallengeColumns} [sortBy]
         * @param {boolean} [sortAsc]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelayers: function (slaSince, page, perPage, sortBy, sortAsc, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.StatsApiAxiosParamCreator(configuration).getRelayers(slaSince, page, perPage, sortBy, sortAsc, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1["default"]; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReplaceStats: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.StatsApiAxiosParamCreator(configuration).getReplaceStats(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1["default"]; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSecureCollateralThreshold: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.StatsApiAxiosParamCreator(configuration).getSecureCollateralThreshold(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1["default"]; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatusUpdateStats: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.StatsApiAxiosParamCreator(configuration).getStatusUpdateStats(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1["default"]; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Returns the total count of issue requests (regardless of execution).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTotalIssues: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.StatsApiAxiosParamCreator(configuration).getTotalIssues(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1["default"]; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Gets the total count of status updates submitted (regardless of voting status).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTotalParachainStatusUpdates: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.StatsApiAxiosParamCreator(configuration).getTotalParachainStatusUpdates(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1["default"]; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Retrieves the total value of polkaBTC successfully redeemed (all time).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTotalRedeemedAmount: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.StatsApiAxiosParamCreator(configuration).getTotalRedeemedAmount(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1["default"]; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Returns the total count of redeem requests (regardless of execution).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTotalRedeems: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.StatsApiAxiosParamCreator(configuration).getTotalRedeems(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1["default"]; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Retrieves the total amount of blocks submitted to BTCRelay.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTotalRelayedBlocksCount: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.StatsApiAxiosParamCreator(configuration).getTotalRelayedBlocksCount(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1["default"]; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Returns the total count of successfully executed issues.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTotalSuccessfulIssues: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.StatsApiAxiosParamCreator(configuration).getTotalSuccessfulIssues(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1["default"]; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Returns the total count of successfully executed redeems.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTotalSuccessfulRedeems: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.StatsApiAxiosParamCreator(configuration).getTotalSuccessfulRedeems(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1["default"]; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Retrieves the total value locked (i.e. polkaBTC issued - redeemed), snapshotted at the given timestamps.
         * @param {Array<number>} days an array of timestamps, in miliseconds since the UNIX epoch
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTvlForTimestamps: function (days, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.StatsApiAxiosParamCreator(configuration).getTvlForTimestamps(days, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1["default"]; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserCountStats: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.StatsApiAxiosParamCreator(configuration).getUserCountStats(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1["default"]; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {number} timestamp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVaultCollateralisationStatsAtTime: function (timestamp, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.StatsApiAxiosParamCreator(configuration).getVaultCollateralisationStatsAtTime(timestamp, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1["default"]; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVaultPunishmentFee: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.StatsApiAxiosParamCreator(configuration).getVaultPunishmentFee(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1["default"]; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVaultStats: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.StatsApiAxiosParamCreator(configuration).getVaultStats(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1["default"]; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Retrieves a paged list of vaults, with all dashboard stats (collateral, locked BTC, etc.)
         * @param {number} [page]
         * @param {number} [perPage]
         * @param {VaultColumns} [sortBy]
         * @param {boolean} [sortAsc]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVaults: function (page, perPage, sortBy, sortAsc, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.StatsApiAxiosParamCreator(configuration).getVaults(page, perPage, sortBy, sortAsc, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1["default"]; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Returns a list of relayers with a minimum SLA track record, as specified by the parameters.
         * @param {number} [minSla] the SLA theshold to consider
         * @param {number} [minConsecutivePeriod] the duration above which the relayer must have had SLA above minSLA (in miliseconds)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRelayersWithTrackRecord: function (minSla, minConsecutivePeriod, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.StatsApiAxiosParamCreator(configuration).listRelayersWithTrackRecord(minSla, minConsecutivePeriod, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1["default"]; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * Returns a list of vaults with a minimum SLA track record, as specified by the parameters.
         * @param {number} [minSla] the SLA theshold to consider
         * @param {number} [minConsecutivePeriod] the duration above which the relayer must have had SLA above minSLA (in miliseconds)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listVaultsWithTrackRecord: function (minSla, minConsecutivePeriod, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.StatsApiAxiosParamCreator(configuration).listVaultsWithTrackRecord(minSla, minConsecutivePeriod, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1["default"]; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        }
    };
};
exports.StatsApiFp = StatsApiFp;
/**
 * StatsApi - factory interface
 * @export
 */
var StatsApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         * Retrieves a paged list of BTC blocks submitted to the relay.
         * @param {number} [page]
         * @param {number} [perPage]
         * @param {BlockColumns} [sortBy]
         * @param {boolean} [sortAsc]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBlocks: function (page, perPage, sortBy, sortAsc, options) {
            return exports.StatsApiFp(configuration).getBlocks(page, perPage, sortBy, sortAsc, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBtcConfirmations: function (options) {
            return exports.StatsApiFp(configuration).getBtcConfirmations(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} slaSince
         * @param {number} [page]
         * @param {number} [perPage]
         * @param {VaultChallengeColumns} [sortBy]
         * @param {boolean} [sortAsc]
         * @param {Array<FilterVaultChallengeColumns>} [filterVaultChallengeColumns]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChallengeFilteredVaults: function (slaSince, page, perPage, sortBy, sortAsc, filterVaultChallengeColumns, options) {
            return exports.StatsApiFp(configuration).getChallengeFilteredVaults(slaSince, page, perPage, sortBy, sortAsc, filterVaultChallengeColumns, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Retrieves a paged list of vaults, with numbers of issue and redeem requests, and the unbounded sum SLA scores after a given cutoff.
         * @param {number} slaSince A UNIX timestamp starting from which the SLA score will be summed.
         * @param {number} [page]
         * @param {number} [perPage]
         * @param {VaultChallengeColumns} [sortBy]
         * @param {boolean} [sortAsc]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChallengeVaults: function (slaSince, page, perPage, sortBy, sortAsc, options) {
            return exports.StatsApiFp(configuration).getChallengeVaults(slaSince, page, perPage, sortBy, sortAsc, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDustValue: function (options) {
            return exports.StatsApiFp(configuration).getDustValue(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} [page]
         * @param {number} [perPage]
         * @param {IssueColumns} [sortBy]
         * @param {boolean} [sortAsc]
         * @param {BtcNetworkName} [network]
         * @param {Array<FilterIssueColumns>} [filterIssueColumns]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilteredIssues: function (page, perPage, sortBy, sortAsc, network, filterIssueColumns, options) {
            return exports.StatsApiFp(configuration).getFilteredIssues(page, perPage, sortBy, sortAsc, network, filterIssueColumns, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} [page]
         * @param {number} [perPage]
         * @param {StatusUpdateColumns} [sortBy]
         * @param {boolean} [sortAsc]
         * @param {Array<FilterStatusUpdateColumns>} [filterStatusUpdateColumns]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilteredParachainStatusUpdates: function (page, perPage, sortBy, sortAsc, filterStatusUpdateColumns, options) {
            return exports.StatsApiFp(configuration).getFilteredParachainStatusUpdates(page, perPage, sortBy, sortAsc, filterStatusUpdateColumns, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} [page]
         * @param {number} [perPage]
         * @param {RedeemColumns} [sortBy]
         * @param {boolean} [sortAsc]
         * @param {BtcNetworkName} [network]
         * @param {Array<FilterRedeemColumns>} [filterRedeemColumns]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilteredRedeems: function (page, perPage, sortBy, sortAsc, network, filterRedeemColumns, options) {
            return exports.StatsApiFp(configuration).getFilteredRedeems(page, perPage, sortBy, sortAsc, network, filterRedeemColumns, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} slaSince
         * @param {number} [page]
         * @param {number} [perPage]
         * @param {RelayerChallengeColumns} [sortBy]
         * @param {boolean} [sortAsc]
         * @param {Array<FilterRelayerChallengeColumns>} [filterRelayerChallengeColumns]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilteredRelayers: function (slaSince, page, perPage, sortBy, sortAsc, filterRelayerChallengeColumns, options) {
            return exports.StatsApiFp(configuration).getFilteredRelayers(slaSince, page, perPage, sortBy, sortAsc, filterRelayerChallengeColumns, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {Array<FilterIssueColumns>} [filterIssueColumns]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilteredTotalIssues: function (filterIssueColumns, options) {
            return exports.StatsApiFp(configuration).getFilteredTotalIssues(filterIssueColumns, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {Array<FilterRedeemColumns>} [filterRedeemColumns]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilteredTotalRedeems: function (filterRedeemColumns, options) {
            return exports.StatsApiFp(configuration).getFilteredTotalRedeems(filterRedeemColumns, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} [page]
         * @param {number} [perPage]
         * @param {VaultColumns} [sortBy]
         * @param {boolean} [sortAsc]
         * @param {Array<FilterVaultColumns>} [filterVaultColumns]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilteredVaults: function (page, perPage, sortBy, sortAsc, filterVaultColumns, options) {
            return exports.StatsApiFp(configuration).getFilteredVaults(page, perPage, sortBy, sortAsc, filterVaultColumns, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFullReport: function (options) {
            return exports.StatsApiFp(configuration).getFullReport(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Retrieves the latest btc block submitted to BTCRelay.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHighestBTCBlock: function (options) {
            return exports.StatsApiFp(configuration).getHighestBTCBlock(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIssueFee: function (options) {
            return exports.StatsApiFp(configuration).getIssueFee(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIssueGriefingCollateral: function (options) {
            return exports.StatsApiFp(configuration).getIssueGriefingCollateral(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIssuePeriod: function (options) {
            return exports.StatsApiFp(configuration).getIssuePeriod(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIssueStats: function (options) {
            return exports.StatsApiFp(configuration).getIssueStats(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Retrieves a paged list of issue requests.
         * @param {number} [page]
         * @param {number} [perPage]
         * @param {IssueColumns} [sortBy]
         * @param {boolean} [sortAsc]
         * @param {BtcNetworkName} [network] the BTC network used for issue transactions; necessary to correctly decode vault addresses and transaction IDs.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIssues: function (page, perPage, sortBy, sortAsc, network, options) {
            return exports.StatsApiFp(configuration).getIssues(page, perPage, sortBy, sortAsc, network, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Retrieves the latest update (from any oracle).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestSubmission: function (options) {
            return exports.StatsApiFp(configuration).getLatestSubmission(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Retrieves the last update from each of the oracles in the system.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestSubmissionForEachOracle: function (options) {
            return exports.StatsApiFp(configuration).getLatestSubmissionForEachOracle(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParachainConstants: function (options) {
            return exports.StatsApiFp(configuration).getParachainConstants(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Retrieves a paged list of parachain status updates.
         * @param {number} [page]
         * @param {number} [perPage]
         * @param {StatusUpdateColumns} [sortBy]
         * @param {boolean} [sortAsc]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParachainStatusUpdates: function (page, perPage, sortBy, sortAsc, options) {
            return exports.StatsApiFp(configuration).getParachainStatusUpdates(page, perPage, sortBy, sortAsc, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPremiumRedeemFee: function (options) {
            return exports.StatsApiFp(configuration).getPremiumRedeemFee(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Gets the total number of collateral locked at midnight for the last several days
         * @param {number} [daysBack] number of days (starting from the next midnight) to give datapoints for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecentDailyCollateralLocked: function (daysBack, options) {
            return exports.StatsApiFp(configuration).getRecentDailyCollateralLocked(daysBack, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Gets the total amount issued before midnight for the last several days
         * @param {number} [daysBack] number of days (starting from the next midnight) to give datapoints for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecentDailyIssues: function (daysBack, options) {
            return exports.StatsApiFp(configuration).getRecentDailyIssues(daysBack, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Gets the total amount redeemed before midnight for the last several days
         * @param {number} [daysBack] number of days (starting from the next midnight) to give datapoints for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecentDailyRedeems: function (daysBack, options) {
            return exports.StatsApiFp(configuration).getRecentDailyRedeems(daysBack, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Gets the total number of relayers registered at midnight for the last several days Does not take into account online status, only registration.
         * @param {number} [daysBack] number of days (starting from the next midnight) to give datapoints for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecentDailyRelayerCounts: function (daysBack, options) {
            return exports.StatsApiFp(configuration).getRecentDailyRelayerCounts(daysBack, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Gets the total number of vaults registered at midnight for the last several days Does not take into account online status, only registration.
         * @param {number} [daysBack] number of days (starting from the next midnight) to give datapoints for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecentDailyVaultCounts: function (daysBack, options) {
            return exports.StatsApiFp(configuration).getRecentDailyVaultCounts(daysBack, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecentVaultCollateralisatonRates: function (options) {
            return exports.StatsApiFp(configuration).getRecentVaultCollateralisatonRates(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRedeemStats: function (options) {
            return exports.StatsApiFp(configuration).getRedeemStats(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Retrieves a paged list of redeem requests.
         * @param {number} [page]
         * @param {number} [perPage]
         * @param {RedeemColumns} [sortBy]
         * @param {boolean} [sortAsc]
         * @param {BtcNetworkName} [network] the BTC network used for redeem transactions; necessary to correctly decode vault addresses and transaction IDs.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRedeems: function (page, perPage, sortBy, sortAsc, network, options) {
            return exports.StatsApiFp(configuration).getRedeems(page, perPage, sortBy, sortAsc, network, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Retrieves a paged list of relayers, along with the unbounded sum SLA scores after a given cutoff.
         * @param {number} slaSince A UNIX timestamp starting from which the SLA score will be summed.
         * @param {number} [page]
         * @param {number} [perPage]
         * @param {RelayerChallengeColumns} [sortBy]
         * @param {boolean} [sortAsc]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelayers: function (slaSince, page, perPage, sortBy, sortAsc, options) {
            return exports.StatsApiFp(configuration).getRelayers(slaSince, page, perPage, sortBy, sortAsc, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReplaceStats: function (options) {
            return exports.StatsApiFp(configuration).getReplaceStats(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSecureCollateralThreshold: function (options) {
            return exports.StatsApiFp(configuration).getSecureCollateralThreshold(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatusUpdateStats: function (options) {
            return exports.StatsApiFp(configuration).getStatusUpdateStats(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns the total count of issue requests (regardless of execution).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTotalIssues: function (options) {
            return exports.StatsApiFp(configuration).getTotalIssues(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Gets the total count of status updates submitted (regardless of voting status).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTotalParachainStatusUpdates: function (options) {
            return exports.StatsApiFp(configuration).getTotalParachainStatusUpdates(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Retrieves the total value of polkaBTC successfully redeemed (all time).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTotalRedeemedAmount: function (options) {
            return exports.StatsApiFp(configuration).getTotalRedeemedAmount(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns the total count of redeem requests (regardless of execution).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTotalRedeems: function (options) {
            return exports.StatsApiFp(configuration).getTotalRedeems(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Retrieves the total amount of blocks submitted to BTCRelay.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTotalRelayedBlocksCount: function (options) {
            return exports.StatsApiFp(configuration).getTotalRelayedBlocksCount(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns the total count of successfully executed issues.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTotalSuccessfulIssues: function (options) {
            return exports.StatsApiFp(configuration).getTotalSuccessfulIssues(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns the total count of successfully executed redeems.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTotalSuccessfulRedeems: function (options) {
            return exports.StatsApiFp(configuration).getTotalSuccessfulRedeems(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Retrieves the total value locked (i.e. polkaBTC issued - redeemed), snapshotted at the given timestamps.
         * @param {Array<number>} days an array of timestamps, in miliseconds since the UNIX epoch
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTvlForTimestamps: function (days, options) {
            return exports.StatsApiFp(configuration).getTvlForTimestamps(days, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserCountStats: function (options) {
            return exports.StatsApiFp(configuration).getUserCountStats(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {number} timestamp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVaultCollateralisationStatsAtTime: function (timestamp, options) {
            return exports.StatsApiFp(configuration).getVaultCollateralisationStatsAtTime(timestamp, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVaultPunishmentFee: function (options) {
            return exports.StatsApiFp(configuration).getVaultPunishmentFee(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVaultStats: function (options) {
            return exports.StatsApiFp(configuration).getVaultStats(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Retrieves a paged list of vaults, with all dashboard stats (collateral, locked BTC, etc.)
         * @param {number} [page]
         * @param {number} [perPage]
         * @param {VaultColumns} [sortBy]
         * @param {boolean} [sortAsc]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVaults: function (page, perPage, sortBy, sortAsc, options) {
            return exports.StatsApiFp(configuration).getVaults(page, perPage, sortBy, sortAsc, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns a list of relayers with a minimum SLA track record, as specified by the parameters.
         * @param {number} [minSla] the SLA theshold to consider
         * @param {number} [minConsecutivePeriod] the duration above which the relayer must have had SLA above minSLA (in miliseconds)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRelayersWithTrackRecord: function (minSla, minConsecutivePeriod, options) {
            return exports.StatsApiFp(configuration).listRelayersWithTrackRecord(minSla, minConsecutivePeriod, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns a list of vaults with a minimum SLA track record, as specified by the parameters.
         * @param {number} [minSla] the SLA theshold to consider
         * @param {number} [minConsecutivePeriod] the duration above which the relayer must have had SLA above minSLA (in miliseconds)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listVaultsWithTrackRecord: function (minSla, minConsecutivePeriod, options) {
            return exports.StatsApiFp(configuration).listVaultsWithTrackRecord(minSla, minConsecutivePeriod, options).then(function (request) { return request(axios, basePath); });
        }
    };
};
exports.StatsApiFactory = StatsApiFactory;
/**
 * StatsApi - object-oriented interface
 * @export
 * @class StatsApi
 * @extends {BaseAPI}
 */
var StatsApi = /** @class */ (function (_super) {
    __extends(StatsApi, _super);
    function StatsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Retrieves a paged list of BTC blocks submitted to the relay.
     * @param {number} [page]
     * @param {number} [perPage]
     * @param {BlockColumns} [sortBy]
     * @param {boolean} [sortAsc]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatsApi
     */
    StatsApi.prototype.getBlocks = function (page, perPage, sortBy, sortAsc, options) {
        var _this = this;
        return exports.StatsApiFp(this.configuration).getBlocks(page, perPage, sortBy, sortAsc, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatsApi
     */
    StatsApi.prototype.getBtcConfirmations = function (options) {
        var _this = this;
        return exports.StatsApiFp(this.configuration).getBtcConfirmations(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} slaSince
     * @param {number} [page]
     * @param {number} [perPage]
     * @param {VaultChallengeColumns} [sortBy]
     * @param {boolean} [sortAsc]
     * @param {Array<FilterVaultChallengeColumns>} [filterVaultChallengeColumns]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatsApi
     */
    StatsApi.prototype.getChallengeFilteredVaults = function (slaSince, page, perPage, sortBy, sortAsc, filterVaultChallengeColumns, options) {
        var _this = this;
        return exports.StatsApiFp(this.configuration).getChallengeFilteredVaults(slaSince, page, perPage, sortBy, sortAsc, filterVaultChallengeColumns, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Retrieves a paged list of vaults, with numbers of issue and redeem requests, and the unbounded sum SLA scores after a given cutoff.
     * @param {number} slaSince A UNIX timestamp starting from which the SLA score will be summed.
     * @param {number} [page]
     * @param {number} [perPage]
     * @param {VaultChallengeColumns} [sortBy]
     * @param {boolean} [sortAsc]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatsApi
     */
    StatsApi.prototype.getChallengeVaults = function (slaSince, page, perPage, sortBy, sortAsc, options) {
        var _this = this;
        return exports.StatsApiFp(this.configuration).getChallengeVaults(slaSince, page, perPage, sortBy, sortAsc, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatsApi
     */
    StatsApi.prototype.getDustValue = function (options) {
        var _this = this;
        return exports.StatsApiFp(this.configuration).getDustValue(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} [page]
     * @param {number} [perPage]
     * @param {IssueColumns} [sortBy]
     * @param {boolean} [sortAsc]
     * @param {BtcNetworkName} [network]
     * @param {Array<FilterIssueColumns>} [filterIssueColumns]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatsApi
     */
    StatsApi.prototype.getFilteredIssues = function (page, perPage, sortBy, sortAsc, network, filterIssueColumns, options) {
        var _this = this;
        return exports.StatsApiFp(this.configuration).getFilteredIssues(page, perPage, sortBy, sortAsc, network, filterIssueColumns, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} [page]
     * @param {number} [perPage]
     * @param {StatusUpdateColumns} [sortBy]
     * @param {boolean} [sortAsc]
     * @param {Array<FilterStatusUpdateColumns>} [filterStatusUpdateColumns]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatsApi
     */
    StatsApi.prototype.getFilteredParachainStatusUpdates = function (page, perPage, sortBy, sortAsc, filterStatusUpdateColumns, options) {
        var _this = this;
        return exports.StatsApiFp(this.configuration).getFilteredParachainStatusUpdates(page, perPage, sortBy, sortAsc, filterStatusUpdateColumns, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} [page]
     * @param {number} [perPage]
     * @param {RedeemColumns} [sortBy]
     * @param {boolean} [sortAsc]
     * @param {BtcNetworkName} [network]
     * @param {Array<FilterRedeemColumns>} [filterRedeemColumns]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatsApi
     */
    StatsApi.prototype.getFilteredRedeems = function (page, perPage, sortBy, sortAsc, network, filterRedeemColumns, options) {
        var _this = this;
        return exports.StatsApiFp(this.configuration).getFilteredRedeems(page, perPage, sortBy, sortAsc, network, filterRedeemColumns, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} slaSince
     * @param {number} [page]
     * @param {number} [perPage]
     * @param {RelayerChallengeColumns} [sortBy]
     * @param {boolean} [sortAsc]
     * @param {Array<FilterRelayerChallengeColumns>} [filterRelayerChallengeColumns]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatsApi
     */
    StatsApi.prototype.getFilteredRelayers = function (slaSince, page, perPage, sortBy, sortAsc, filterRelayerChallengeColumns, options) {
        var _this = this;
        return exports.StatsApiFp(this.configuration).getFilteredRelayers(slaSince, page, perPage, sortBy, sortAsc, filterRelayerChallengeColumns, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {Array<FilterIssueColumns>} [filterIssueColumns]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatsApi
     */
    StatsApi.prototype.getFilteredTotalIssues = function (filterIssueColumns, options) {
        var _this = this;
        return exports.StatsApiFp(this.configuration).getFilteredTotalIssues(filterIssueColumns, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {Array<FilterRedeemColumns>} [filterRedeemColumns]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatsApi
     */
    StatsApi.prototype.getFilteredTotalRedeems = function (filterRedeemColumns, options) {
        var _this = this;
        return exports.StatsApiFp(this.configuration).getFilteredTotalRedeems(filterRedeemColumns, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} [page]
     * @param {number} [perPage]
     * @param {VaultColumns} [sortBy]
     * @param {boolean} [sortAsc]
     * @param {Array<FilterVaultColumns>} [filterVaultColumns]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatsApi
     */
    StatsApi.prototype.getFilteredVaults = function (page, perPage, sortBy, sortAsc, filterVaultColumns, options) {
        var _this = this;
        return exports.StatsApiFp(this.configuration).getFilteredVaults(page, perPage, sortBy, sortAsc, filterVaultColumns, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatsApi
     */
    StatsApi.prototype.getFullReport = function (options) {
        var _this = this;
        return exports.StatsApiFp(this.configuration).getFullReport(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Retrieves the latest btc block submitted to BTCRelay.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatsApi
     */
    StatsApi.prototype.getHighestBTCBlock = function (options) {
        var _this = this;
        return exports.StatsApiFp(this.configuration).getHighestBTCBlock(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatsApi
     */
    StatsApi.prototype.getIssueFee = function (options) {
        var _this = this;
        return exports.StatsApiFp(this.configuration).getIssueFee(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatsApi
     */
    StatsApi.prototype.getIssueGriefingCollateral = function (options) {
        var _this = this;
        return exports.StatsApiFp(this.configuration).getIssueGriefingCollateral(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatsApi
     */
    StatsApi.prototype.getIssuePeriod = function (options) {
        var _this = this;
        return exports.StatsApiFp(this.configuration).getIssuePeriod(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatsApi
     */
    StatsApi.prototype.getIssueStats = function (options) {
        var _this = this;
        return exports.StatsApiFp(this.configuration).getIssueStats(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Retrieves a paged list of issue requests.
     * @param {number} [page]
     * @param {number} [perPage]
     * @param {IssueColumns} [sortBy]
     * @param {boolean} [sortAsc]
     * @param {BtcNetworkName} [network] the BTC network used for issue transactions; necessary to correctly decode vault addresses and transaction IDs.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatsApi
     */
    StatsApi.prototype.getIssues = function (page, perPage, sortBy, sortAsc, network, options) {
        var _this = this;
        return exports.StatsApiFp(this.configuration).getIssues(page, perPage, sortBy, sortAsc, network, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Retrieves the latest update (from any oracle).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatsApi
     */
    StatsApi.prototype.getLatestSubmission = function (options) {
        var _this = this;
        return exports.StatsApiFp(this.configuration).getLatestSubmission(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Retrieves the last update from each of the oracles in the system.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatsApi
     */
    StatsApi.prototype.getLatestSubmissionForEachOracle = function (options) {
        var _this = this;
        return exports.StatsApiFp(this.configuration).getLatestSubmissionForEachOracle(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatsApi
     */
    StatsApi.prototype.getParachainConstants = function (options) {
        var _this = this;
        return exports.StatsApiFp(this.configuration).getParachainConstants(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Retrieves a paged list of parachain status updates.
     * @param {number} [page]
     * @param {number} [perPage]
     * @param {StatusUpdateColumns} [sortBy]
     * @param {boolean} [sortAsc]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatsApi
     */
    StatsApi.prototype.getParachainStatusUpdates = function (page, perPage, sortBy, sortAsc, options) {
        var _this = this;
        return exports.StatsApiFp(this.configuration).getParachainStatusUpdates(page, perPage, sortBy, sortAsc, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatsApi
     */
    StatsApi.prototype.getPremiumRedeemFee = function (options) {
        var _this = this;
        return exports.StatsApiFp(this.configuration).getPremiumRedeemFee(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Gets the total number of collateral locked at midnight for the last several days
     * @param {number} [daysBack] number of days (starting from the next midnight) to give datapoints for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatsApi
     */
    StatsApi.prototype.getRecentDailyCollateralLocked = function (daysBack, options) {
        var _this = this;
        return exports.StatsApiFp(this.configuration).getRecentDailyCollateralLocked(daysBack, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Gets the total amount issued before midnight for the last several days
     * @param {number} [daysBack] number of days (starting from the next midnight) to give datapoints for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatsApi
     */
    StatsApi.prototype.getRecentDailyIssues = function (daysBack, options) {
        var _this = this;
        return exports.StatsApiFp(this.configuration).getRecentDailyIssues(daysBack, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Gets the total amount redeemed before midnight for the last several days
     * @param {number} [daysBack] number of days (starting from the next midnight) to give datapoints for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatsApi
     */
    StatsApi.prototype.getRecentDailyRedeems = function (daysBack, options) {
        var _this = this;
        return exports.StatsApiFp(this.configuration).getRecentDailyRedeems(daysBack, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Gets the total number of relayers registered at midnight for the last several days Does not take into account online status, only registration.
     * @param {number} [daysBack] number of days (starting from the next midnight) to give datapoints for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatsApi
     */
    StatsApi.prototype.getRecentDailyRelayerCounts = function (daysBack, options) {
        var _this = this;
        return exports.StatsApiFp(this.configuration).getRecentDailyRelayerCounts(daysBack, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Gets the total number of vaults registered at midnight for the last several days Does not take into account online status, only registration.
     * @param {number} [daysBack] number of days (starting from the next midnight) to give datapoints for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatsApi
     */
    StatsApi.prototype.getRecentDailyVaultCounts = function (daysBack, options) {
        var _this = this;
        return exports.StatsApiFp(this.configuration).getRecentDailyVaultCounts(daysBack, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatsApi
     */
    StatsApi.prototype.getRecentVaultCollateralisatonRates = function (options) {
        var _this = this;
        return exports.StatsApiFp(this.configuration).getRecentVaultCollateralisatonRates(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatsApi
     */
    StatsApi.prototype.getRedeemStats = function (options) {
        var _this = this;
        return exports.StatsApiFp(this.configuration).getRedeemStats(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Retrieves a paged list of redeem requests.
     * @param {number} [page]
     * @param {number} [perPage]
     * @param {RedeemColumns} [sortBy]
     * @param {boolean} [sortAsc]
     * @param {BtcNetworkName} [network] the BTC network used for redeem transactions; necessary to correctly decode vault addresses and transaction IDs.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatsApi
     */
    StatsApi.prototype.getRedeems = function (page, perPage, sortBy, sortAsc, network, options) {
        var _this = this;
        return exports.StatsApiFp(this.configuration).getRedeems(page, perPage, sortBy, sortAsc, network, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Retrieves a paged list of relayers, along with the unbounded sum SLA scores after a given cutoff.
     * @param {number} slaSince A UNIX timestamp starting from which the SLA score will be summed.
     * @param {number} [page]
     * @param {number} [perPage]
     * @param {RelayerChallengeColumns} [sortBy]
     * @param {boolean} [sortAsc]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatsApi
     */
    StatsApi.prototype.getRelayers = function (slaSince, page, perPage, sortBy, sortAsc, options) {
        var _this = this;
        return exports.StatsApiFp(this.configuration).getRelayers(slaSince, page, perPage, sortBy, sortAsc, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatsApi
     */
    StatsApi.prototype.getReplaceStats = function (options) {
        var _this = this;
        return exports.StatsApiFp(this.configuration).getReplaceStats(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatsApi
     */
    StatsApi.prototype.getSecureCollateralThreshold = function (options) {
        var _this = this;
        return exports.StatsApiFp(this.configuration).getSecureCollateralThreshold(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatsApi
     */
    StatsApi.prototype.getStatusUpdateStats = function (options) {
        var _this = this;
        return exports.StatsApiFp(this.configuration).getStatusUpdateStats(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns the total count of issue requests (regardless of execution).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatsApi
     */
    StatsApi.prototype.getTotalIssues = function (options) {
        var _this = this;
        return exports.StatsApiFp(this.configuration).getTotalIssues(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Gets the total count of status updates submitted (regardless of voting status).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatsApi
     */
    StatsApi.prototype.getTotalParachainStatusUpdates = function (options) {
        var _this = this;
        return exports.StatsApiFp(this.configuration).getTotalParachainStatusUpdates(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Retrieves the total value of polkaBTC successfully redeemed (all time).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatsApi
     */
    StatsApi.prototype.getTotalRedeemedAmount = function (options) {
        var _this = this;
        return exports.StatsApiFp(this.configuration).getTotalRedeemedAmount(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns the total count of redeem requests (regardless of execution).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatsApi
     */
    StatsApi.prototype.getTotalRedeems = function (options) {
        var _this = this;
        return exports.StatsApiFp(this.configuration).getTotalRedeems(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Retrieves the total amount of blocks submitted to BTCRelay.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatsApi
     */
    StatsApi.prototype.getTotalRelayedBlocksCount = function (options) {
        var _this = this;
        return exports.StatsApiFp(this.configuration).getTotalRelayedBlocksCount(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns the total count of successfully executed issues.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatsApi
     */
    StatsApi.prototype.getTotalSuccessfulIssues = function (options) {
        var _this = this;
        return exports.StatsApiFp(this.configuration).getTotalSuccessfulIssues(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns the total count of successfully executed redeems.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatsApi
     */
    StatsApi.prototype.getTotalSuccessfulRedeems = function (options) {
        var _this = this;
        return exports.StatsApiFp(this.configuration).getTotalSuccessfulRedeems(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Retrieves the total value locked (i.e. polkaBTC issued - redeemed), snapshotted at the given timestamps.
     * @param {Array<number>} days an array of timestamps, in miliseconds since the UNIX epoch
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatsApi
     */
    StatsApi.prototype.getTvlForTimestamps = function (days, options) {
        var _this = this;
        return exports.StatsApiFp(this.configuration).getTvlForTimestamps(days, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatsApi
     */
    StatsApi.prototype.getUserCountStats = function (options) {
        var _this = this;
        return exports.StatsApiFp(this.configuration).getUserCountStats(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {number} timestamp
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatsApi
     */
    StatsApi.prototype.getVaultCollateralisationStatsAtTime = function (timestamp, options) {
        var _this = this;
        return exports.StatsApiFp(this.configuration).getVaultCollateralisationStatsAtTime(timestamp, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatsApi
     */
    StatsApi.prototype.getVaultPunishmentFee = function (options) {
        var _this = this;
        return exports.StatsApiFp(this.configuration).getVaultPunishmentFee(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatsApi
     */
    StatsApi.prototype.getVaultStats = function (options) {
        var _this = this;
        return exports.StatsApiFp(this.configuration).getVaultStats(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Retrieves a paged list of vaults, with all dashboard stats (collateral, locked BTC, etc.)
     * @param {number} [page]
     * @param {number} [perPage]
     * @param {VaultColumns} [sortBy]
     * @param {boolean} [sortAsc]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatsApi
     */
    StatsApi.prototype.getVaults = function (page, perPage, sortBy, sortAsc, options) {
        var _this = this;
        return exports.StatsApiFp(this.configuration).getVaults(page, perPage, sortBy, sortAsc, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns a list of relayers with a minimum SLA track record, as specified by the parameters.
     * @param {number} [minSla] the SLA theshold to consider
     * @param {number} [minConsecutivePeriod] the duration above which the relayer must have had SLA above minSLA (in miliseconds)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatsApi
     */
    StatsApi.prototype.listRelayersWithTrackRecord = function (minSla, minConsecutivePeriod, options) {
        var _this = this;
        return exports.StatsApiFp(this.configuration).listRelayersWithTrackRecord(minSla, minConsecutivePeriod, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns a list of vaults with a minimum SLA track record, as specified by the parameters.
     * @param {number} [minSla] the SLA theshold to consider
     * @param {number} [minConsecutivePeriod] the duration above which the relayer must have had SLA above minSLA (in miliseconds)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatsApi
     */
    StatsApi.prototype.listVaultsWithTrackRecord = function (minSla, minConsecutivePeriod, options) {
        var _this = this;
        return exports.StatsApiFp(this.configuration).listVaultsWithTrackRecord(minSla, minConsecutivePeriod, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return StatsApi;
}(base_1.BaseAPI));
exports.StatsApi = StatsApi;
